var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 7.63672C0.875 7.3291 1.00684 7.0127 1.22656 6.80176L6.97461 1.05371C7.2207 0.807617 7.50195 0.693359 7.7832 0.693359C8.43359 0.693359 8.89062 1.15918 8.89062 1.76562C8.89062 2.09961 8.75 2.36328 8.54785 2.57422L6.55273 4.57812L4.3291 6.61719L6.30664 6.51172H16.5986C17.293 6.51172 17.7588 6.96875 17.7588 7.63672C17.7588 8.30469 17.293 8.76172 16.5986 8.76172H6.30664L4.3291 8.64746L6.55273 10.6953L8.54785 12.6904C8.75 12.9014 8.89062 13.165 8.89062 13.499C8.89062 14.1143 8.43359 14.5713 7.7832 14.5713C7.50195 14.5713 7.22949 14.457 6.99219 14.2197L1.22656 8.47168C1.00684 8.25195 0.875 7.94434 0.875 7.63672Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.8b768064.svg";
export { ForwardRef as ReactComponent };